
<v-btn-toggle
    v-model = "modes"
    color   = "primary"
    @change = onModes
    multiple
    dense
    rounded
    group
>
    <v-btn
        value = "all-orders"
        class = "disposition-button"
    >
        <v-icon size="22" color="primary">mdi-folder</v-icon>
        <span class="pl-1">{{ $t("disposition.modes.allOrders") }}</span>
    </v-btn>

    <v-btn
        value = "map"
        class = "disposition-button"
    >
        <v-icon size="22" color="primary">mdi-map</v-icon>
        <span>{{ $t("disposition.modes.map") }} </span>
    </v-btn>

    <v-btn
        v-if  = "isDisponent && !isAllOrdersOn"
        value = "assign"
        class = "disposition-button"
    >
        <v-icon size="22" color="primary">mdi-plus</v-icon>
        <span>{{ $t("disposition.modes.assign") }} </span>
    </v-btn>

    <v-btn
        v-if  = "isDispatcher || isDispatcher || isRestrictedDispatcher"
        value = "dispatch"
        class = "disposition-button"
    >
        <v-icon size="22" color="primary">mdi-account</v-icon>
        <span>{{ $t("disposition.modes.dispatch") }}</span>
    </v-btn>

</v-btn-toggle>
